import { render, staticRenderFns } from "./PremiumPartnersOverview.vue?vue&type=template&id=6707d301"
import script from "./PremiumPartnersOverview.vue?vue&type=script&lang=js"
export * from "./PremiumPartnersOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports